var main = {
    jsToggles: function() {
        var linkToggle = document.querySelectorAll('.js-toggle');

        for(var i = 0; i < linkToggle.length; i++) {
        linkToggle[i].addEventListener('click', function(event) {
        
        event.preventDefault();
        
        var container = document.getElementById(this.dataset.container);
        
        if (!container.classList.contains('active')) {
            this.classList.add('is-open');
            container.classList.add('active');
            container.style.height = 'auto';
        
            var height = container.clientHeight + 'px';
        
            container.style.height = '0px';
        
            var parentContainer = container.closest('.sub-parent')
        
        
            setTimeout(function () {
            container.style.height = height;
                if (parentContainer != undefined && parentContainer.clientHeight > 0) {
                setTimeout( function() {
                    parentContainer.style.height = 'auto';
                    var parentHeight = parentContainer.clientHeight + 'px';
            
                    parentContainer.style.height = '0px';
        
                    parentContainer.style.height = parentHeight;
                }, 100)
                }
            }, 0);
            
        } else {
            this.classList.remove('is-open');
            
            container.style.height = '0px';
        
            if (container.classList.contains('no-trans')) {
            container.classList.remove('active');
            } else {
            container.addEventListener('transitionend', function () {
                container.classList.remove('active');
            }, {
                once: true
            });
            }
            
            setTimeout(function () {
            var parentContainer = container.closest('.sub-parent')
            var innerSub = container.closest('.inner-sub')
        
            if (innerSub != null) {
                parentContainer.style.height = innerSub.clientHeight + 'px';
            }
            }, 100);
        }
        
        });
        
        }
    }
}

main.jsToggles()








// Clean Read More Function - Simple and Effective
document.addEventListener('DOMContentLoaded', function() {
  const productDescriptions = document.querySelectorAll('.product__description');
  
  productDescriptions.forEach(function(description) {
    // Check schema setting - skip if disabled
    if (description.dataset.enableReadmore === 'false') return;
    
    const fullHTML = description.innerHTML.trim();
    
    // Get text length to check if we need read more
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = fullHTML;
    const fullText = tempDiv.textContent || tempDiv.innerText || '';
    
    if (fullText.length > 210) {
      // Create the truncated version
      const truncatedHTML = truncateHTMLPreservingStructure(fullHTML, 210);
      
      // Create the wrapper div that will contain everything
      const wrapper = document.createElement('div');
      wrapper.className = 'description-content';
      
      // Create the button
      const readMoreBtn = document.createElement('button');
      readMoreBtn.className = 'read-more-btn';
      readMoreBtn.textContent = 'Read more';
      readMoreBtn.setAttribute('aria-expanded', 'false');
      
      // Set up the collapsed state
      wrapper.innerHTML = truncatedHTML;
      wrapper.appendChild(readMoreBtn);
      
      // Replace the original content
      description.innerHTML = '';
      description.appendChild(wrapper);
      
      // Add click handler
      readMoreBtn.addEventListener('click', function() {
        const isExpanded = readMoreBtn.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
          // Collapse
          wrapper.innerHTML = truncatedHTML;
          wrapper.appendChild(readMoreBtn);
          readMoreBtn.textContent = 'Read more';
          readMoreBtn.setAttribute('aria-expanded', 'false');
        } else {
          // Expand
          wrapper.innerHTML = fullHTML;
          wrapper.appendChild(readMoreBtn);
          readMoreBtn.textContent = 'Read less';
          readMoreBtn.setAttribute('aria-expanded', 'true');
        }
      });
    }
  });
});

function truncateHTMLPreservingStructure(html, maxChars) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${html}</div>`, 'text/html');
  const container = doc.querySelector('div');
  
  let charCount = 0;
  let truncated = false;
  
  function processElement(element) {
    const clone = element.cloneNode(false);
    
    for (const child of element.childNodes) {
      if (truncated) break;
      
      if (child.nodeType === Node.TEXT_NODE) {
        const text = child.textContent;
        const remainingChars = maxChars - charCount;
        
        if (text.length <= remainingChars) {
          clone.appendChild(child.cloneNode());
          charCount += text.length;
        } else {
          // Truncate the text and add ellipsis
          let truncatedText = text.substring(0, remainingChars);
          
          // Try to end at a word boundary
          const lastSpace = truncatedText.lastIndexOf(' ');
          if (lastSpace > remainingChars * 0.7) {
            truncatedText = truncatedText.substring(0, lastSpace);
          }
          
          // Add the truncated text with ellipsis
          clone.appendChild(document.createTextNode(truncatedText + '...'));
          truncated = true;
          break;
        }
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        // Handle special elements that should always be preserved
        const tagName = child.tagName.toLowerCase();
        const className = child.className || '';
        const isSpecial = ['svg', 'img', 'i'].includes(tagName) || 
                         className.includes('icon') || 
                         className.includes('check') || 
                         className.includes('symbol');
        
        if (isSpecial) {
          clone.appendChild(child.cloneNode(true));
        } else {
          const processedChild = processElement(child);
          if (processedChild.hasChildNodes() || processedChild.textContent.trim()) {
            clone.appendChild(processedChild);
          }
        }
      }
    }
    
    return clone;
  }
  
  const result = processElement(container);
  return result.innerHTML;
}




// Close all accordions on page load
document.addEventListener('DOMContentLoaded', function() {
  // Find all details elements within accordion containers
  const accordionDetails = document.querySelectorAll('.product__accordion details');
  
  accordionDetails.forEach(function(details) {
    // Remove the 'open' attribute to close the accordion
    details.removeAttribute('open');
    
    // Update aria-expanded on the summary element
    const summary = details.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
  });
});




// feature typeface
document.addEventListener('DOMContentLoaded', function() {
  // Just add new selectors to this array
  const headingTargets = [
    '.featured-collection__heading-template--18443661934804__featured_collection_wjDP3Y',
    '.iwt__heading-template--18443661934804__image_with_text_dPmr46',
    '.iwt__heading-template--18443661934804__image_with_text_gUnkNn',
    '.rich-text__block-heading-template--18443661934804__rich_text_Nip6aD',
    '.collection__title h2',
    '.template-product h2',
    '.template-collection h2'
    // Add more as needed...
  ];
  
  // Apply heading-lead class to all targets
  headingTargets.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.classList.add('heading-lead');
    });
  });
});



// Remove "Estimated between" delivery date from cart
(function() {
  function removeEstimatedDelivery() {
    const productOptions = document.querySelectorAll('.product-option');
    
    productOptions.forEach(option => {
      const dt = option.querySelector('dt');
      if (dt && dt.textContent.trim() === 'Estimated between:') {
        option.remove();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', removeEstimatedDelivery);
})();


// REMOVE VERTICAL FROM NAV LIST ITEM
document.addEventListener('DOMContentLoaded', function() {
  // Select all product title elements in the menu drawer
  const productTitles = document.querySelectorAll('.ddb__menu-drawer__collection--product-title');
  
  // Loop through each title and remove "Vertical"
  productTitles.forEach(function(title) {
    title.textContent = title.textContent.replace(/\s*Vertical\s*/gi, ' ').trim();
  });
});




// landing-page wrapping shadow — restricted to specific pages
(function() {
  // Only run on these exact page slugs
  const targetSlugs = [
    'jb-racks-lp-campaign-001',
    'jb-racks-lp-campaign-002',
    'jb-racks-lp-campaign-003'
  ];

  const currentPath = window.location.pathname;
  const isTargetPage = targetSlugs.some(slug => currentPath.endsWith('/' + slug));

  if (!isTargetPage) {
    return;
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapSections);
  } else {
    wrapSections();
  }

  function wrapSections() {
    const main = document.querySelector('#MainContent');
    if (!main) return;

    // Get all direct children sections/divs with shopify-section class
    const allSections = Array.from(main.children).filter(child =>
      child.classList.contains('shopify-section') ||
      child.id.includes('shopify-section')
    );

    // Skip the first section
    const sectionsToWrap = allSections.slice(1);

    if (sectionsToWrap.length === 0) return;

    // Create the wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'boxed-in-shadow';

    // Insert wrapper after the first section
    const firstSection = allSections[0];
    firstSection.parentNode.insertBefore(wrapper, firstSection.nextSibling);

    // Move all sections (except first) into the wrapper
    sectionsToWrap.forEach(section => {
      wrapper.appendChild(section);
    });

    // Add the styles
    addStyles();
  }

  function addStyles() {
    // Check if styles already exist
    if (document.getElementById('boxed-in-shadow-styles')) return;

    const style = document.createElement('style');
    style.id = 'boxed-in-shadow-styles';
    style.textContent = `
      .boxed-in-shadow {
        max-width: 1400px;
        margin: 0 auto;
        background: #ffffff;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 
                    0 2px 4px -1px rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        overflow: hidden;
      }

      /* Adjust on mobile for less shadow/padding */
      @media screen and (max-width: 749px) {
        .boxed-in-shadow {
          margin: 0 10px;
          box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.08);
        }
      }
    `;
    document.head.appendChild(style);
  }
})();






// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  const bikeSwitcher = document.querySelector('.bike-rack-switcher');
  const colorVariant = document.querySelector('#custom-unified-color');
  
  if (bikeSwitcher && colorVariant) {
    // Create wrapper div
    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'display: flex; gap: 20px; align-items: flex-start; margin-bottom: 20px;';
    
    // Style the components
    bikeSwitcher.style.cssText = 'flex: 1;';
    colorVariant.style.cssText = 'margin-bottom: 0;';
    
    // Insert wrapper before bikeSwitcher
    bikeSwitcher.parentNode.insertBefore(wrapper, bikeSwitcher);
    
    // Move both elements into wrapper
    wrapper.appendChild(bikeSwitcher);
    wrapper.appendChild(colorVariant);
  }
});




document.addEventListener('DOMContentLoaded', function() {
  const firstProduct = document.querySelector('#Slide-template--20487477657812__featured_collection_CGTiC9-1 .card__inner');
  if (firstProduct) {
    const badge = document.createElement('div');
    badge.className = 'popular-choice-badge';
    badge.textContent = '80% Choose This';
    firstProduct.insertBefore(badge, firstProduct.firstChild);
  }
});




window.addEventListener('pageshow', function(event) {
    if (!event.persisted) return;
    document.querySelectorAll('product-form [type="submit"]').forEach(function(btn) {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('disabled');
        var spinner = btn.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
        var text = btn.querySelector('span');
        if (text && window.variantStrings && window.variantStrings.addToCart) {
            text.textContent = window.variantStrings.addToCart;
        }
    });
});




// COMMENT NORMALISATION FOR RACKS

(function() {
  let lastRating = null;
  let lastCount = null;
  
  function syncReviewCounts() {
    // Get the bottom widget data
    const bottomRating = document.querySelector('.oke-w-ratingAverageModule-rating-average');
    const bottomCount = document.querySelector('.oke-w-ratingAverageModule-count');
    
    if (!bottomRating || !bottomCount) {
      return false;
    }
    
    const rating = bottomRating.textContent.trim();
    const countText = bottomCount.textContent.trim();
    const countMatch = countText.match(/\d+/);
    
    if (!countMatch || !rating) {
      return false;
    }
    
    const count = countMatch[0];
    
    // Only update if values have changed (prevents unnecessary DOM updates)
    if (rating === lastRating && count === lastCount) {
      return true;
    }
    
    lastRating = rating;
    lastCount = count;
    
    // Update top widget rating number
    const topRating = document.querySelector('[data-oke-star-rating] .oke-sr-rating');
    if (topRating) topRating.textContent = ' ' + rating + ' ';
    
    // Update top widget count
    const topCountNumber = document.querySelector('[data-oke-star-rating] .oke-sr-count-number');
    if (topCountNumber) topCountNumber.textContent = count;
    
    // Update top widget stars width
    const topStarsForeground = document.querySelector('[data-oke-star-rating] .oke-stars-foreground');
    if (topStarsForeground) {
      topStarsForeground.style.width = (parseFloat(rating) * 20) + '%';
    }
    
    // Update accessibility text
    const topA11yText = document.querySelector('[data-oke-star-rating] .oke-stars .oke-a11yText');
    if (topA11yText) {
      topA11yText.textContent = 'Rated ' + rating + ' out of 5 stars';
    }
    
    return true;
  }
  
  // Continuously check every 500ms - simple and reliable
  setInterval(syncReviewCounts, 500);
})();



// CART ADDED TO KLAVIYO DELAY FOR TRACKING

// (function() {
//   var cooldown = 15000; // 15 seconds
//   var lastSentTime = 0;

//   setInterval(function() {
//     var cartCountEl = document.querySelector('.cart-count-bubble, [data-cart-count], .cart__count');
//     if (!cartCountEl) return;

//     var cartCount = parseInt(cartCountEl.textContent.trim() || '0', 10);
//     if (!cartCount || isNaN(cartCount)) return;

//     if (!window._lastCartCount) window._lastCartCount = 0;

//     // Detect increase in cart count
//     if (cartCount > window._lastCartCount) {
//       var now = Date.now();
//       if (now - lastSentTime < cooldown) {
//         console.log('⏳ Skipping: event already sent in last 15s');
//       } else {
//         console.log('🎯 CART INCREASED! Sending to Klaviyo...');
//         lastSentTime = now; // start cooldown

//         fetch('/cart.js')
//           .then(r => r.json())
//           .then(cart => {
//             if (window._learnq && cart.items.length > 0) {
//               var item = cart.items[cart.items.length - 1];

//               _learnq.push(['track', 'Added to Cart', {
//                 '$value': item.final_price / 100,
//                 'AddedItemProductName': item.product_title,
//                 'AddedItemProductID': item.product_id,
//                 'AddedItemSKU': item.sku || '',
//                 'AddedItemImageURL': item.image || '',
//                 'AddedItemURL': window.location.origin + item.url,
//                 'AddedItemPrice': item.final_price / 100,
//                 'AddedItemQuantity': item.quantity,
//                 'ItemNames': [item.product_title],
//                 'CheckoutURL': window.location.origin + '/cart'
//               }]);

//               console.log('✅ SENT TO KLAVIYO:', item.product_title);
//             }
//           })
//           .catch(err => console.warn('❌ Error fetching cart:', err));
//       }
//     }

//     window._lastCartCount = cartCount;
//   }, 500);
// })();




document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    if (!viewer) return;

    var oldPrev = viewer.querySelector('.slider-button--prev');
    var oldNext = viewer.querySelector('.slider-button--next');
    if (!oldPrev || !oldNext) return;

    var prevBtn = oldPrev.cloneNode(true);
    var nextBtn = oldNext.cloneNode(true);
    oldPrev.parentNode.replaceChild(prevBtn, oldPrev);
    oldNext.parentNode.replaceChild(nextBtn, oldNext);

    function getVisibleThumbButtons() {
      return Array.from(gallery.querySelectorAll('.thumbnail-list__item'))
        .filter(function (li) { return li.style.display !== 'none'; })
        .map(function (li) { return li.querySelector('.thumbnail'); })
        .filter(Boolean);
    }

    function click(step) {
      var thumbs = getVisibleThumbButtons();
      if (thumbs.length < 2) return;
      var current = thumbs.findIndex(function (btn) { return btn.getAttribute('aria-current') === 'true'; });
      if (current === -1) current = 0;
      var next = (current + step + thumbs.length) % thumbs.length;
      thumbs[next].click();
    }

    prevBtn.addEventListener('click', function (e) { e.preventDefault(); click(-1); });
    nextBtn.addEventListener('click', function (e) { e.preventDefault(); click(1); });
  });
});


/* =====================================================================
   BAYMARD-OPTIMISED PDP  —  template: product.e-bike-racks-v2-baymard
   Runs only when .bym-pdp exists on the page.
   Pushes {event:'bym_interaction', bym_action, bym_label} to dataLayer.
   ===================================================================== */
(function () {
  'use strict';

  function track(action, label) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'bym_interaction', bym_action: action, bym_label: label || '' });
    } catch (e) {}
  }

  function init() {
    var root = document.querySelector('.bym-pdp');
    if (!root || root.getAttribute('data-bym-ready')) return;
    root.setAttribute('data-bym-ready', '1');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var currency = root.getAttribute('data-currency') || 'USD';
    var locale = root.getAttribute('data-locale') || 'en-US';

    /* ---------- Sticky-header offset ---------- */
    var header = document.querySelector('.section-header');
    var headerOffset = function () {
      if (!header) return 0;
      var pos = getComputedStyle(header).position;
      if (pos !== 'sticky' && pos !== 'fixed') return 0;
      return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    };

    /* ---------- Smooth in-page jumps (rating link, nav, spec links) ---------- */
    var goTo = function (hash, src) {
      if (!hash || hash.charAt(0) !== '#') return false;
      var el = document.getElementById(hash.slice(1));
      if (!el) return false;
      if (el.tagName === 'DETAILS') el.open = true;
      var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 64;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', hash);
      track('jump', hash.slice(1) + (src ? ':' + src : ''));
      return true;
    };
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-bym-scroll], .bym-nav__links a');
      if (a && goTo(a.getAttribute('href'), a.getAttribute('data-bym-scroll') || 'nav')) e.preventDefault();
      var t = e.target.closest('[data-bym-track]');
      if (t) track('click', t.getAttribute('data-bym-track'));
    });

    /* ---------- Money + live variant updates (Dawn pub/sub) ---------- */
    var money = function (cents) {
      var n = cents / 100;
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n);
      } catch (e) { return '$' + n.toFixed(n % 1 ? 2 : 0); }
    };

    var syncPreorder = function () {
      var line = document.querySelector('[data-bym-eta-line]');
      if (!line) return;
      var info = document.querySelector('.product__info-container') || document.body;
      var txt = '';
      info.querySelectorAll('[class*="stock"], [class*="preorder"], [class*="pre-order"], [class*="delivery"]').forEach(function (n) {
        if (n.offsetParent !== null && !n.closest('.bym-assure')) txt += ' ' + n.textContent;
      });
      line.hidden = /pre-?order|expected delivery/i.test(txt);
    };

    var onVariant = function (v) {
      if (!v) return;
      var save = document.querySelector('[data-bym-save]');
      if (save) {
        var diff = (v.compare_at_price || 0) - v.price;
        var amt = save.querySelector('[data-bym-save-amt]');
        if (diff > 0 && amt) { amt.textContent = money(diff); save.hidden = false; } else { save.hidden = true; }
      }
      document.querySelectorAll('[data-bym-price]').forEach(function (el) { el.textContent = money(v.price); });
      var btn = document.querySelector('[data-bym-atc]');
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      setTimeout(syncPreorder, 350);
    };
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (evt) { onVariant(evt && evt.data && evt.data.variant); });
      }
    } catch (e) {}

    /* ---------- Delivery date estimate + assurance tiles ---------- */
    var assure = document.querySelector('[data-bym-assure]');
    if (assure) {
      var min = parseInt(assure.getAttribute('data-min'), 10) || 4;
      var max = parseInt(assure.getAttribute('data-max'), 10) || 7;
      var cutoffAttr = assure.getAttribute('data-cutoff');
      var cutoff = cutoffAttr ? parseInt(cutoffAttr, 10) : null;
      var holidays = (assure.getAttribute('data-holidays') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var iso = function (d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); };
      var workday = function (d) { var w = d.getDay(); return w !== 0 && w !== 6 && holidays.indexOf(iso(d)) === -1; };
      var addBiz = function (start, n) { var d = new Date(start), c = 0; while (c < n) { d.setDate(d.getDate() + 1); if (workday(d)) c++; } return d; };
      var start = new Date(); start.setHours(12, 0, 0, 0);
      if (!workday(start) || (cutoff !== null && new Date().getHours() >= cutoff)) start = addBiz(start, 1);
      var fmt;
      try { fmt = new Intl.DateTimeFormat(locale, { weekday: 'short', month: 'short', day: 'numeric' }); }
      catch (e) { fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
      var etaEl = assure.querySelector('[data-bym-eta]');
      if (etaEl) {
        var dA = addBiz(start, min), dB = addBiz(start, max);
        var mon = function (d) { try { return d.toLocaleDateString(locale, { month: 'short' }); } catch (e) { return d.toLocaleDateString('en-US', { month: 'short' }); } };
        etaEl.textContent = dA.getMonth() === dB.getMonth()
          ? mon(dA) + ' ' + dA.getDate() + '–' + dB.getDate()
          : mon(dA) + ' ' + dA.getDate() + ' – ' + mon(dB) + ' ' + dB.getDate();
      }

      assure.addEventListener('click', function (e) {
        var tile = e.target.closest('.bym-assure__tile');
        if (!tile) return;
        var wasOpen = tile.getAttribute('aria-expanded') === 'true';
        assure.querySelectorAll('.bym-assure__tile').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        assure.querySelectorAll('.bym-assure__panel').forEach(function (p) { p.hidden = true; });
        if (!wasOpen) {
          tile.setAttribute('aria-expanded', 'true');
          var panel = document.getElementById(tile.getAttribute('aria-controls'));
          if (panel) panel.hidden = false;
          track('assurance', tile.getAttribute('data-panel'));
        }
      });
    }

    /* ---------- Fit checker ---------- */
    var fit = document.querySelector('[data-bym-fit]');
    if (fit) {
      var answers = {};
      var out = fit.querySelector('.bym-fit__result');
      fit.addEventListener('toggle', function () { if (fit.open) track('fit_open'); });
      fit.addEventListener('click', function (e) {
        var chip = e.target.closest('.bym-chip');
        if (!chip) return;
        var q = chip.closest('[data-q]').getAttribute('data-q');
        chip.parentNode.querySelectorAll('.bym-chip').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        answers[q] = chip.getAttribute('data-a');
        track('fit_' + q, answers[q]);
        var html = '', warn = false;
        ['hitch', 'wheel'].forEach(function (k) {
          if (!answers[k]) return;
          var tpl = fit.querySelector('template[data-r="' + k + '-' + answers[k] + '"]');
          if (tpl) { html += '<p>' + tpl.innerHTML + '</p>'; if (tpl.getAttribute('data-tone') === 'warn') warn = true; }
        });
        out.innerHTML = html;
        out.setAttribute('data-tone', warn ? 'warn' : 'ok');
        if (answers.hitch === '2' && answers.wheel === 'adult') track('fit_pass');
      });
    }

    /* ---------- Fixed section nav ---------- */
    var nav = document.querySelector('[data-bym-nav]');
    if (nav) {
      document.body.appendChild(nav);
      nav.inert = true;
      var links = Array.prototype.slice.call(nav.querySelectorAll('.bym-nav__links a'));
      var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
      links.forEach(function (a, i) { if (!targets[i]) a.hidden = true; });

      var buyArea = document.querySelector('.product-form__buttons') || document.querySelector('product-info');
      if ('IntersectionObserver' in window && buyArea) {
        new IntersectionObserver(function (entries) {
          var en = entries[0];
          var on = !en.isIntersecting && en.boundingClientRect.top < 0;
          nav.classList.toggle('is-on', on);
          nav.inert = !on;
        }).observe(buyArea);
      }

      var ticking = false;
      var onScroll = function () {
        ticking = false;
        var off = headerOffset();
        nav.style.top = off + 'px';
        var line = off + nav.offsetHeight + 72, cur = -1;
        targets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top <= line) cur = i; });
        links.forEach(function (a, i) {
          a.classList.toggle('is-active', i === cur);
          if (i === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        });
        if (cur > -1 && nav.classList.contains('is-on')) {
          var box = links[cur].parentNode, l = links[cur].offsetLeft - 16;
          if (Math.abs(box.scrollLeft - l) > box.clientWidth / 2) box.scrollLeft = l;
        }
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
      onScroll();

      var atc = nav.querySelector('[data-bym-atc]');
      if (atc) atc.addEventListener('click', function () {
        track('nav_atc');
        var main = document.querySelector('.product-form__submit');
        if (main && !main.disabled && main.getAttribute('aria-disabled') !== 'true') { main.click(); return; }
        var tgt = document.querySelector('variant-selects, .product-form__input, product-info');
        if (tgt) tgt.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    }

    syncPreorder();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* ===================== END BAYMARD-OPTIMISED PDP ===================== */
